import React from "react";

const CodeDisplay = (props) => {
  if (props.split) {
    return (
      <iframe
        width="100%"
        height="100%"
        className="iframe-style"
        title="Code exec"
        srcDoc={`<html><body><style>${props.css}</style>${props.html}<script type="text/javascript">
        ${props.js}
          </script></body></html>`}
      ></iframe>
    );
  } else {
    return (
      <iframe
        width="100%"
        height="100%"
        title="Code exec"
        className="iframe-style"
        srcDoc={`<html><body>${props.execCode}<script type="text/javascript">
          </script></body></html>`}
      ></iframe>
    );
  }
};
export default CodeDisplay;
